import { createFileRoute } from '@tanstack/react-router';
import { getActiveSupplyPoint } from '@/features/supply-points/utils/resolveActiveSupplyPoint';
import { deviceQueries } from '@/features/devices/queries';
import { DevicesPage } from '@/features/devices/pages/DevicesPage';
import { DetailsPageSkeleton } from '@/common/components/loading-skeleton/DetailsPageSkeleton';

export const Route = createFileRoute('/_authenticated/_supply-point-scope/devices/')({
  component: DevicesPage,
  pendingComponent: DetailsPageSkeleton,
  loader: async ({ context: { queryClient } }) => {
    const activeSupplyPoint = await getActiveSupplyPoint(queryClient);

    if (activeSupplyPoint) {
      await Promise.all([
        queryClient.ensureQueryData(deviceQueries.list()),
        queryClient.ensureQueryData(deviceQueries.types()),
      ]);
    }
  },
});
